module.exports = require('./helpers/bundle-url').getBundleURL('iQ9Fn') + "logo.c51670a8.svg";